<template>
   <div class="d-flex justify-center align-center flex-column" :style="{ width: '100%', margin: '0 auto', maxWidth: '100%' }">
   <InformationAlert />
  <v-card
    class="d-flex pa-2 flex-column align-center justify-center"
    outlined
    :style="{
      'margin-bottom': '40px',
      width: '80%',
      'min-height': '550px',
      height: 'fit-content',
    }"
    elevation="2"
  >
    <h3 class="ma-2 text-center">Bulk upload generate QRIS Statis</h3>
    <div
      class="d-flex flex-row justify-center align-center flex-wrap"
      :style="{
        'text-align': 'center',
        width: '100%',
        padding: '50px 0px 50px 0px',
      }"
    >
      <div class="d-flex flex-column justify-center align-center" style="flex: 1">
        <v-row align="center" class="ma-1" style="width: 60%">
          <v-file-input
            label="Insert file here (.xlsx)"
            placeholder="Select your files"
            persistent-hint
            outlined
            prepend-inner-icon="mdi-paperclip"
            prepend-icon=""
            :error-messages="fileError"
            accept=".xlsx"
            @change="validateFile"
          />
        </v-row>
        <v-row class="mb-1">
          <v-btn
            small
            :loading="loadingDownloadTemplate"
            :disabled="loadingDownloadTemplate"
            @click="downloadBaseTemplate"
          >
            Download Template
          </v-btn>
        </v-row>

        <v-row align="center" class="mb-4 mt-2">
          <v-btn 
            small 
            color="success" 
            :disabled="fileError || !file"
            @click="uploadFile"
          >
            Upload
            <v-icon right dark> mdi-cloud-upload </v-icon>
          </v-btn>
        </v-row>
      </div>
    </div>

    <template>
      <p class="text-justify text-caption">
        Note:<br />
        Maximum 10,000 rows to insert transaction data.
      </p>
    </template>
  </v-card>
</div>
</template>

<script>
export default {
  components: {
    InformationAlert: () => import('./InformationAlert.vue'),
  },
  name: "BulkUpload",
  data() {
    return {
      file: null,
      fileError: "",
      insertProgress: 0,
      onInsert: false,
      loading: false,
      loadingDownloadTemplate: false,
    };
  },
  methods: {
    validateFile(file) {
      this.fileError = "";

      if (!file) {
        this.fileError = "File is required.";
        this.file = null;
        return;
      }

      const fileExtension = file.name.split(".").pop().toLowerCase();
      if (fileExtension !== "xlsx") {
        this.fileError = "Only .xlsx files are allowed.";
        this.file = null;
        return;
      }

      this.file = file;
    },
    async uploadFile() {
      if (!this.file) {
        this.fileError = "No file selected.";
        return;
      }

      this.loading = true;

      try {
        await this.$store.dispatch("generateQrStatis/bulkUpload", {
          payload: { file: this.file },
        });

        this.$emit("upload-success"); 
      } catch (error) {
        this.$emit("upload-failed", error);
      } finally {
        this.loading = false;
      }
    },
    async downloadBaseTemplate() {
      this.loadingDownloadTemplate = true;
      try {
        const response = await this.$store.dispatch(
          'generateQrStatis/downloadTemplate'
        );
        if (response) {
          const blob = new Blob([response.data]);
          const fileUrl = URL.createObjectURL(blob);
          const contentDisposition =
            response.headers['content-disposition'] || '';
          const fileNameMatch = contentDisposition.match(
            /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i
          );
          const fileName = fileNameMatch
            ? decodeURIComponent(fileNameMatch[1])
            : 'template-generate-qr-statis.xlsx';
          const link = document.createElement('a');
          link.href = fileUrl;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(fileUrl);
        }
      } finally {
        this.loadingDownloadTemplate = false;
      }
    },
  },
};
</script>
